import React from 'react';
import { ReactComponent as Facebook } from '../../../assets/images/icon-fb.svg';
import { ReactComponent as LinkedIn } from '../../../assets/images/icon-in.svg';
import { ReactComponent as Twitter } from '../../../assets/images/icon-twitter.svg';
import { ReactComponent as Instagram } from '../../../assets/images/icon-instagram.svg';
import { ReactComponent as Youtube } from '../../../assets/images/icon-yt.svg';

const footerLinks = {
  about: [
    {
      text: 'footer_title1_item1',
      link: '/bizdocs'
    },
    {
      text: 'footer_title1_item2',
      link: '/bizdocs/benefits'
    },
    {
      text: 'footer_title1_item3',
      link: '/bizdocs/security'
    },
    {
      text: 'footer_title1_item4',
      link: '/bizdocs/digital-archive'
    },
    {
      text: 'footer_title1_item5',
      link: '/plans'
    },
    {
      text: 'footer_title1_item6',
      link: '/news'
    },
    {
      text: 'footer_title1_item7',
      link: '/bizdocs/about-us'
    }
  ],
  portal: [
    {
      text: 'footer_title2_item1',
      link: '/accounting-offices'
     },
    {
      text: 'footer_title2_item2',
      link: '/plans/accounting-offices/free'
    }
  ],
  empresas: [
    {
      text: 'footer_title3_item1',
      link: '/companies'
    },
    {
      text: 'footer_title3_item2',
      link: '/plans/companies/free'
    }
   /* {
      text: 'footer_title3_item3',
      Link: ''
    }*/
  ],
  login: [
    /*{
      text: 'footer_title4_item1',
      link: '/identity/account/register'
    },*/
    {
      text: 'footer_title4_item2',
      link: '/privacy-policy'
    },
    {
      text: 'footer_title4_item3',
      link: '/terms'
    },
    {
      text: 'footer_title4_item4',
      link: '/site-map'
    }
  ],
  social: [
    {
        logo: <Facebook />,
        alt: 'Facebook',
        to: 'https://www.facebook.com/bizdocs'
    },
    {
      logo: <LinkedIn />,
        alt: 'LinkedIn',
        to: 'https://www.linkedin.com/company/bizdocs/'
    },
    {
      logo: <Twitter />,
        alt: 'Twitter',
        to: 'https://twitter.com/bizdocscs'
    },
    {
      logo: <Instagram />,
        alt: 'Instagram',
        to: 'https://www.instagram.com/bizdocscs'
    },
    {
      logo: <Youtube />,
      alt: 'Youtube',
      to:'https://www.youtube.com/channel/UC2tLGnbQgD9ERRMpcEQQe5A'
    }
  ]
};

export default footerLinks;
